import { ListItem, Div, Span, Text, Image } from "@tblabs/truffle";
import { Basket } from "../../Services/Basket/Basket";
import { BasketItem } from "../../Services/Basket/BasketItem";
import { AmountControl } from "./AmountControl";
import { RemoveFromBasketButton } from "./RemoveFromBasketButton";


export class MiniBasketItem extends ListItem
{
    constructor(item: BasketItem, basket: Basket)
    {
        super("");

        const productUrl = "#produkt/" + (item.Product?.Url?.value ?? "") + "/" + item.ProductOptionId.value;

        this.Class("cart-summary__item").Append(
            new Div("cart-summary__item-row cart-summary__item-row--name").Append(
                new Div("cart-summary__item-name-columns").Append(
                    new Image(item.Product?.Images.Items[0]?.MiniUrl).Class("cart-summary__item-thumbnail")
                        .OnClick(() => window.location.href = productUrl).CursorPointer(),
                    new Div("cart-summary__item-title-details").Append(
                        new Span(item.Product?.BasketName.value || "Produkt już niedostępny").Class("text-label-lg")
                            .OnClick(() => window.location.href = productUrl).CursorPointer(),
                        new Div("cart-summary__item-meta text-meta").Text(item.Label.value),
                    ),
                ),
                new RemoveFromBasketButton().OnClick(() => basket.Remove(item))
            ),
            new Div("cart-summary__item-row cart-summary__item-row--qty").Append(
                new Div("cart-summary__item-row-qty-inner").Append(
                    new AmountControl(item.Quantity),
                    new Div("cart-summary__item-row-qty-right").Append(
                        new Text(item.FinalPriceAfterDiscount, v => v + " zł").Class("cart-summary__item-price")
                    )
                )
            )
        );
    }
}
